// Returns only the additional modals contributed by mfe-shared.
// Host apps should merge this with core modals (buildModalsRegistry) and grid modals.
// Note: symbolSelector removed - applications should register it directly if needed
export function buildSharedModalsRegistry() {
  const registry = {}
  return registry
}
